import React from "react";
import { DayModifiers } from "react-day-picker";
import { isWeekend, todayInSydney } from "../../../utils/dayjs";
import { ToolTipLite } from "../ToolTipLite";

interface RentalDatePickerDayProps {
  date: Date;
  modifiers?: DayModifiers;
}

export const RentalDatePickerDay: React.FC<RentalDatePickerDayProps> = (props) => {
  function _tooltipText() {
    if (props.modifiers && !props.modifiers.disabled) {
      return null;
    }

    const date = props.date;
    const today = todayInSydney();
    const tomorrow = today.add(1, "day");

    if (tomorrow.isSame(date, "day")) {
      return (
        <span>
          Next day delivery is only available in capital cities. <br />
          Order must be placed before 12:00PM AEST.
        </span>
      );
    }

    if (isWeekend(date)) {
      return <span>No deliveries on weekends</span>;
    }

    if (today.isSame(date, "day")) {
      return (
        <span>
          Same day delivery is only available in Sydney metro area. <br />
          Order must be placed before 12:00PM AEST.
        </span>
      );
    }

    return (
      <span>
        Grey dates: Unavailable
        <br />
        White dates: Available
      </span>
    );
  }

  const tooltipText = _tooltipText();
  const dayContent = <div className="DayPicker-Day__content">{props.date.getDate()}</div>;
  if (tooltipText) {
    const day = props.date.getDay();
    let position: "left" | "right" | undefined;
    if (day === 0) {
      position = "right";
    } else if (day === 6) {
      position = "left";
    }

    return (
      <ToolTipLite overlayStyle={{ zIndex: 9999999 }} overlayPosition={position} overlay={tooltipText}>
        {dayContent}
      </ToolTipLite>
    );
  } else {
    return dayContent;
  }
};
